
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        }
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("l5zTV"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("iNDQU"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("1NoYK"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("8DJjD"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("4VCDS"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("62kO3"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("5FRq9"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("lMIvp"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("7nyvx"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("3LGIA"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("1yl1k"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("61oIX"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("l5zTV", function(module, exports) {

let $f5a5e9c64f4643b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5a5e9c64f4643b8$var$load("28xhU"),
    $f5a5e9c64f4643b8$var$load("2YffH"),
    $f5a5e9c64f4643b8$var$load("8Kivm"),
    $f5a5e9c64f4643b8$var$load("aT7sf"),
    $f5a5e9c64f4643b8$var$load("fRvqe"),
    $f5a5e9c64f4643b8$var$load("iQ0Jm"),
    $f5a5e9c64f4643b8$var$load("ev7SX"),
    $f5a5e9c64f4643b8$var$load("cFEDt"),
    $f5a5e9c64f4643b8$var$load("68ZlI"),
    $f5a5e9c64f4643b8$var$load("h4Nf7"),
    $f5a5e9c64f4643b8$var$load("7f9Fz"),
    $f5a5e9c64f4643b8$var$load("8YSo7"),
    $f5a5e9c64f4643b8$var$load("lYvov"),
    $f5a5e9c64f4643b8$var$load("k8XPW"),
    $f5a5e9c64f4643b8$var$load("fWCRm"),
    $f5a5e9c64f4643b8$var$load("g9CVe"),
    $f5a5e9c64f4643b8$var$load("aeEUI"),
    $f5a5e9c64f4643b8$var$load("eY3St"),
    $f5a5e9c64f4643b8$var$load("bkd4T"),
    $f5a5e9c64f4643b8$var$load("awqCy"),
    $f5a5e9c64f4643b8$var$load("6wr18"),
    $f5a5e9c64f4643b8$var$load("kjZZD"),
    $f5a5e9c64f4643b8$var$load("3ySTn"),
    $f5a5e9c64f4643b8$var$load("c2rHL"),
    $f5a5e9c64f4643b8$var$load("kHOMt"),
    $f5a5e9c64f4643b8$var$load("hhss7"),
    $f5a5e9c64f4643b8$var$load("cB5rV"),
    $f5a5e9c64f4643b8$var$load("aKnnM"),
    $f5a5e9c64f4643b8$var$load("iZU4p"),
    $f5a5e9c64f4643b8$var$load("Wowvf"),
    $f5a5e9c64f4643b8$var$load("ffEVr"),
    $f5a5e9c64f4643b8$var$load("jlSv2"),
    $f5a5e9c64f4643b8$var$load("1UUrt"),
    $f5a5e9c64f4643b8$var$load("1hmnv"),
    $f5a5e9c64f4643b8$var$load("1faui"),
    $f5a5e9c64f4643b8$var$load("kWZnd"),
    $f5a5e9c64f4643b8$var$load("92LGf"),
    $f5a5e9c64f4643b8$var$load("iqKwT"),
    $f5a5e9c64f4643b8$var$load("jyfIr"),
    $f5a5e9c64f4643b8$var$load("9IeAj"),
    $f5a5e9c64f4643b8$var$load("kUbUu"),
    $f5a5e9c64f4643b8$var$load("2PePB"),
    $f5a5e9c64f4643b8$var$load("lnKog"),
    $f5a5e9c64f4643b8$var$load("9ftJe"),
    $f5a5e9c64f4643b8$var$load("h3ABO"),
    $f5a5e9c64f4643b8$var$load("kC80R"),
    $f5a5e9c64f4643b8$var$load("7EorR"),
    $f5a5e9c64f4643b8$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("iNDQU", function(module, exports) {

let $dafbb775f9e833af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dafbb775f9e833af$var$load("28xhU"),
    $dafbb775f9e833af$var$load("2YffH"),
    $dafbb775f9e833af$var$load("8Kivm"),
    $dafbb775f9e833af$var$load("aT7sf"),
    $dafbb775f9e833af$var$load("fRvqe"),
    $dafbb775f9e833af$var$load("iQ0Jm"),
    $dafbb775f9e833af$var$load("ev7SX"),
    $dafbb775f9e833af$var$load("cFEDt"),
    $dafbb775f9e833af$var$load("68ZlI"),
    $dafbb775f9e833af$var$load("h4Nf7"),
    $dafbb775f9e833af$var$load("7f9Fz"),
    $dafbb775f9e833af$var$load("8YSo7"),
    $dafbb775f9e833af$var$load("lYvov"),
    $dafbb775f9e833af$var$load("k8XPW"),
    $dafbb775f9e833af$var$load("fWCRm"),
    $dafbb775f9e833af$var$load("g9CVe"),
    $dafbb775f9e833af$var$load("aeEUI"),
    $dafbb775f9e833af$var$load("eY3St"),
    $dafbb775f9e833af$var$load("bkd4T"),
    $dafbb775f9e833af$var$load("awqCy"),
    $dafbb775f9e833af$var$load("6wr18"),
    $dafbb775f9e833af$var$load("kjZZD"),
    $dafbb775f9e833af$var$load("3ySTn"),
    $dafbb775f9e833af$var$load("c2rHL"),
    $dafbb775f9e833af$var$load("kHOMt"),
    $dafbb775f9e833af$var$load("hhss7"),
    $dafbb775f9e833af$var$load("cB5rV"),
    $dafbb775f9e833af$var$load("aKnnM"),
    $dafbb775f9e833af$var$load("iZU4p"),
    $dafbb775f9e833af$var$load("Wowvf"),
    $dafbb775f9e833af$var$load("ffEVr"),
    $dafbb775f9e833af$var$load("jlSv2"),
    $dafbb775f9e833af$var$load("1UUrt"),
    $dafbb775f9e833af$var$load("1hmnv"),
    $dafbb775f9e833af$var$load("1faui"),
    $dafbb775f9e833af$var$load("kWZnd"),
    $dafbb775f9e833af$var$load("92LGf"),
    $dafbb775f9e833af$var$load("iqKwT"),
    $dafbb775f9e833af$var$load("jyfIr"),
    $dafbb775f9e833af$var$load("9IeAj"),
    $dafbb775f9e833af$var$load("kUbUu"),
    $dafbb775f9e833af$var$load("2PePB"),
    $dafbb775f9e833af$var$load("lnKog"),
    $dafbb775f9e833af$var$load("9ftJe"),
    $dafbb775f9e833af$var$load("h3ABO"),
    $dafbb775f9e833af$var$load("kC80R"),
    $dafbb775f9e833af$var$load("7EorR"),
    $dafbb775f9e833af$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("1NoYK", function(module, exports) {

let $14edbe5587a31f43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14edbe5587a31f43$var$load("28xhU"),
    $14edbe5587a31f43$var$load("2YffH"),
    $14edbe5587a31f43$var$load("8Kivm"),
    $14edbe5587a31f43$var$load("aT7sf"),
    $14edbe5587a31f43$var$load("fRvqe"),
    $14edbe5587a31f43$var$load("iQ0Jm"),
    $14edbe5587a31f43$var$load("ev7SX"),
    $14edbe5587a31f43$var$load("cFEDt"),
    $14edbe5587a31f43$var$load("68ZlI"),
    $14edbe5587a31f43$var$load("h4Nf7"),
    $14edbe5587a31f43$var$load("7f9Fz"),
    $14edbe5587a31f43$var$load("8YSo7"),
    $14edbe5587a31f43$var$load("lYvov"),
    $14edbe5587a31f43$var$load("k8XPW"),
    $14edbe5587a31f43$var$load("fWCRm"),
    $14edbe5587a31f43$var$load("g9CVe"),
    $14edbe5587a31f43$var$load("aeEUI"),
    $14edbe5587a31f43$var$load("eY3St"),
    $14edbe5587a31f43$var$load("bkd4T"),
    $14edbe5587a31f43$var$load("awqCy"),
    $14edbe5587a31f43$var$load("6wr18"),
    $14edbe5587a31f43$var$load("kjZZD"),
    $14edbe5587a31f43$var$load("3ySTn"),
    $14edbe5587a31f43$var$load("c2rHL"),
    $14edbe5587a31f43$var$load("kHOMt"),
    $14edbe5587a31f43$var$load("hhss7"),
    $14edbe5587a31f43$var$load("cB5rV"),
    $14edbe5587a31f43$var$load("aKnnM"),
    $14edbe5587a31f43$var$load("iZU4p"),
    $14edbe5587a31f43$var$load("Wowvf"),
    $14edbe5587a31f43$var$load("ffEVr"),
    $14edbe5587a31f43$var$load("jlSv2"),
    $14edbe5587a31f43$var$load("1UUrt"),
    $14edbe5587a31f43$var$load("1hmnv"),
    $14edbe5587a31f43$var$load("1faui"),
    $14edbe5587a31f43$var$load("kWZnd"),
    $14edbe5587a31f43$var$load("92LGf"),
    $14edbe5587a31f43$var$load("iqKwT"),
    $14edbe5587a31f43$var$load("jyfIr"),
    $14edbe5587a31f43$var$load("9IeAj"),
    $14edbe5587a31f43$var$load("kUbUu"),
    $14edbe5587a31f43$var$load("2PePB"),
    $14edbe5587a31f43$var$load("lnKog"),
    $14edbe5587a31f43$var$load("9ftJe"),
    $14edbe5587a31f43$var$load("h3ABO"),
    $14edbe5587a31f43$var$load("kC80R"),
    $14edbe5587a31f43$var$load("7EorR"),
    $14edbe5587a31f43$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("8DJjD", function(module, exports) {

let $64a51dfcc282b069$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64a51dfcc282b069$var$load("28xhU"),
    $64a51dfcc282b069$var$load("k8XPW"),
    $64a51dfcc282b069$var$load("fWCRm"),
    $64a51dfcc282b069$var$load("2YffH"),
    $64a51dfcc282b069$var$load("2PePB"),
    $64a51dfcc282b069$var$load("aT7sf"),
    $64a51dfcc282b069$var$load("fRvqe"),
    $64a51dfcc282b069$var$load("cFEDt"),
    $64a51dfcc282b069$var$load("68ZlI"),
    $64a51dfcc282b069$var$load("h4Nf7"),
    $64a51dfcc282b069$var$load("7f9Fz"),
    $64a51dfcc282b069$var$load("8YSo7"),
    $64a51dfcc282b069$var$load("lYvov"),
    $64a51dfcc282b069$var$load("g9CVe"),
    $64a51dfcc282b069$var$load("aeEUI"),
    $64a51dfcc282b069$var$load("eY3St"),
    $64a51dfcc282b069$var$load("bkd4T"),
    $64a51dfcc282b069$var$load("awqCy"),
    $64a51dfcc282b069$var$load("6wr18"),
    $64a51dfcc282b069$var$load("kjZZD"),
    $64a51dfcc282b069$var$load("3ySTn"),
    $64a51dfcc282b069$var$load("c2rHL"),
    $64a51dfcc282b069$var$load("kHOMt"),
    $64a51dfcc282b069$var$load("hhss7"),
    $64a51dfcc282b069$var$load("cB5rV"),
    $64a51dfcc282b069$var$load("aKnnM"),
    $64a51dfcc282b069$var$load("iZU4p"),
    $64a51dfcc282b069$var$load("Wowvf"),
    $64a51dfcc282b069$var$load("ffEVr"),
    $64a51dfcc282b069$var$load("jlSv2"),
    $64a51dfcc282b069$var$load("1UUrt"),
    $64a51dfcc282b069$var$load("1hmnv"),
    $64a51dfcc282b069$var$load("1faui"),
    $64a51dfcc282b069$var$load("kWZnd"),
    $64a51dfcc282b069$var$load("92LGf"),
    $64a51dfcc282b069$var$load("iqKwT"),
    $64a51dfcc282b069$var$load("jyfIr"),
    $64a51dfcc282b069$var$load("9IeAj"),
    $64a51dfcc282b069$var$load("kUbUu"),
    $64a51dfcc282b069$var$load("9ftJe"),
    $64a51dfcc282b069$var$load("h3ABO"),
    $64a51dfcc282b069$var$load("kC80R"),
    $64a51dfcc282b069$var$load("7EorR"),
    $64a51dfcc282b069$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("4VCDS", function(module, exports) {

let $396a75d723374079$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $396a75d723374079$var$load("28xhU"),
    $396a75d723374079$var$load("k8XPW"),
    $396a75d723374079$var$load("fWCRm"),
    $396a75d723374079$var$load("2YffH"),
    $396a75d723374079$var$load("2PePB"),
    $396a75d723374079$var$load("aT7sf"),
    $396a75d723374079$var$load("fRvqe"),
    $396a75d723374079$var$load("cFEDt"),
    $396a75d723374079$var$load("68ZlI"),
    $396a75d723374079$var$load("h4Nf7"),
    $396a75d723374079$var$load("7f9Fz"),
    $396a75d723374079$var$load("8YSo7"),
    $396a75d723374079$var$load("lYvov"),
    $396a75d723374079$var$load("g9CVe"),
    $396a75d723374079$var$load("aeEUI"),
    $396a75d723374079$var$load("eY3St"),
    $396a75d723374079$var$load("bkd4T"),
    $396a75d723374079$var$load("awqCy"),
    $396a75d723374079$var$load("6wr18"),
    $396a75d723374079$var$load("kjZZD"),
    $396a75d723374079$var$load("3ySTn"),
    $396a75d723374079$var$load("c2rHL"),
    $396a75d723374079$var$load("kHOMt"),
    $396a75d723374079$var$load("hhss7"),
    $396a75d723374079$var$load("cB5rV"),
    $396a75d723374079$var$load("aKnnM"),
    $396a75d723374079$var$load("iZU4p"),
    $396a75d723374079$var$load("Wowvf"),
    $396a75d723374079$var$load("ffEVr"),
    $396a75d723374079$var$load("jlSv2"),
    $396a75d723374079$var$load("1UUrt"),
    $396a75d723374079$var$load("1hmnv"),
    $396a75d723374079$var$load("1faui"),
    $396a75d723374079$var$load("kWZnd"),
    $396a75d723374079$var$load("92LGf"),
    $396a75d723374079$var$load("iqKwT"),
    $396a75d723374079$var$load("jyfIr"),
    $396a75d723374079$var$load("9IeAj"),
    $396a75d723374079$var$load("kUbUu"),
    $396a75d723374079$var$load("9ftJe"),
    $396a75d723374079$var$load("h3ABO"),
    $396a75d723374079$var$load("kC80R"),
    $396a75d723374079$var$load("7EorR"),
    $396a75d723374079$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("62kO3", function(module, exports) {

let $465311acde343259$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $465311acde343259$var$load("28xhU"),
    $465311acde343259$var$load("k8XPW"),
    $465311acde343259$var$load("fWCRm"),
    $465311acde343259$var$load("2YffH"),
    $465311acde343259$var$load("2PePB"),
    $465311acde343259$var$load("aT7sf"),
    $465311acde343259$var$load("fRvqe"),
    $465311acde343259$var$load("cFEDt"),
    $465311acde343259$var$load("68ZlI"),
    $465311acde343259$var$load("h4Nf7"),
    $465311acde343259$var$load("7f9Fz"),
    $465311acde343259$var$load("8YSo7"),
    $465311acde343259$var$load("lYvov"),
    $465311acde343259$var$load("g9CVe"),
    $465311acde343259$var$load("aeEUI"),
    $465311acde343259$var$load("eY3St"),
    $465311acde343259$var$load("bkd4T"),
    $465311acde343259$var$load("awqCy"),
    $465311acde343259$var$load("6wr18"),
    $465311acde343259$var$load("kjZZD"),
    $465311acde343259$var$load("3ySTn"),
    $465311acde343259$var$load("c2rHL"),
    $465311acde343259$var$load("kHOMt"),
    $465311acde343259$var$load("hhss7"),
    $465311acde343259$var$load("cB5rV"),
    $465311acde343259$var$load("aKnnM"),
    $465311acde343259$var$load("iZU4p"),
    $465311acde343259$var$load("Wowvf"),
    $465311acde343259$var$load("ffEVr"),
    $465311acde343259$var$load("jlSv2"),
    $465311acde343259$var$load("1UUrt"),
    $465311acde343259$var$load("1hmnv"),
    $465311acde343259$var$load("1faui"),
    $465311acde343259$var$load("kWZnd"),
    $465311acde343259$var$load("92LGf"),
    $465311acde343259$var$load("iqKwT"),
    $465311acde343259$var$load("jyfIr"),
    $465311acde343259$var$load("9IeAj"),
    $465311acde343259$var$load("kUbUu"),
    $465311acde343259$var$load("9ftJe"),
    $465311acde343259$var$load("h3ABO"),
    $465311acde343259$var$load("kC80R"),
    $465311acde343259$var$load("7EorR"),
    $465311acde343259$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("5FRq9", function(module, exports) {

let $421a385d62e69502$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $421a385d62e69502$var$load("28xhU"),
    $421a385d62e69502$var$load("k8XPW"),
    $421a385d62e69502$var$load("fWCRm"),
    $421a385d62e69502$var$load("2YffH"),
    $421a385d62e69502$var$load("aT7sf"),
    $421a385d62e69502$var$load("fRvqe"),
    $421a385d62e69502$var$load("cFEDt"),
    $421a385d62e69502$var$load("68ZlI"),
    $421a385d62e69502$var$load("h4Nf7"),
    $421a385d62e69502$var$load("7f9Fz"),
    $421a385d62e69502$var$load("8YSo7"),
    $421a385d62e69502$var$load("lYvov"),
    $421a385d62e69502$var$load("g9CVe"),
    $421a385d62e69502$var$load("aeEUI"),
    $421a385d62e69502$var$load("eY3St"),
    $421a385d62e69502$var$load("bkd4T"),
    $421a385d62e69502$var$load("awqCy"),
    $421a385d62e69502$var$load("6wr18"),
    $421a385d62e69502$var$load("kjZZD"),
    $421a385d62e69502$var$load("3ySTn"),
    $421a385d62e69502$var$load("c2rHL"),
    $421a385d62e69502$var$load("kHOMt"),
    $421a385d62e69502$var$load("hhss7"),
    $421a385d62e69502$var$load("cB5rV"),
    $421a385d62e69502$var$load("aKnnM"),
    $421a385d62e69502$var$load("iZU4p"),
    $421a385d62e69502$var$load("Wowvf"),
    $421a385d62e69502$var$load("ffEVr"),
    $421a385d62e69502$var$load("jlSv2"),
    $421a385d62e69502$var$load("1UUrt"),
    $421a385d62e69502$var$load("1hmnv"),
    $421a385d62e69502$var$load("1faui"),
    $421a385d62e69502$var$load("kWZnd"),
    $421a385d62e69502$var$load("92LGf"),
    $421a385d62e69502$var$load("iqKwT"),
    $421a385d62e69502$var$load("jyfIr"),
    $421a385d62e69502$var$load("9IeAj"),
    $421a385d62e69502$var$load("kUbUu"),
    $421a385d62e69502$var$load("2PePB"),
    $421a385d62e69502$var$load("lnKog"),
    $421a385d62e69502$var$load("9ftJe"),
    $421a385d62e69502$var$load("h3ABO"),
    $421a385d62e69502$var$load("kC80R"),
    $421a385d62e69502$var$load("7EorR"),
    $421a385d62e69502$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("lMIvp", function(module, exports) {

let $fdc09a8f996c63ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fdc09a8f996c63ba$var$load("28xhU"),
    $fdc09a8f996c63ba$var$load("2YffH"),
    $fdc09a8f996c63ba$var$load("aT7sf"),
    $fdc09a8f996c63ba$var$load("fRvqe"),
    $fdc09a8f996c63ba$var$load("ev7SX"),
    $fdc09a8f996c63ba$var$load("cFEDt"),
    $fdc09a8f996c63ba$var$load("68ZlI"),
    $fdc09a8f996c63ba$var$load("h4Nf7"),
    $fdc09a8f996c63ba$var$load("7f9Fz"),
    $fdc09a8f996c63ba$var$load("8YSo7"),
    $fdc09a8f996c63ba$var$load("lYvov"),
    $fdc09a8f996c63ba$var$load("k8XPW"),
    $fdc09a8f996c63ba$var$load("fWCRm"),
    $fdc09a8f996c63ba$var$load("g9CVe"),
    $fdc09a8f996c63ba$var$load("aeEUI"),
    $fdc09a8f996c63ba$var$load("eY3St"),
    $fdc09a8f996c63ba$var$load("bkd4T"),
    $fdc09a8f996c63ba$var$load("dTsOE"),
    $fdc09a8f996c63ba$var$load("awqCy"),
    $fdc09a8f996c63ba$var$load("6wr18"),
    $fdc09a8f996c63ba$var$load("kjZZD"),
    $fdc09a8f996c63ba$var$load("3ySTn"),
    $fdc09a8f996c63ba$var$load("c2rHL"),
    $fdc09a8f996c63ba$var$load("kHOMt"),
    $fdc09a8f996c63ba$var$load("hhss7"),
    $fdc09a8f996c63ba$var$load("cB5rV"),
    $fdc09a8f996c63ba$var$load("aKnnM"),
    $fdc09a8f996c63ba$var$load("iZU4p"),
    $fdc09a8f996c63ba$var$load("Wowvf"),
    $fdc09a8f996c63ba$var$load("ffEVr"),
    $fdc09a8f996c63ba$var$load("jlSv2"),
    $fdc09a8f996c63ba$var$load("1UUrt"),
    $fdc09a8f996c63ba$var$load("1hmnv"),
    $fdc09a8f996c63ba$var$load("1faui"),
    $fdc09a8f996c63ba$var$load("kWZnd"),
    $fdc09a8f996c63ba$var$load("92LGf"),
    $fdc09a8f996c63ba$var$load("iqKwT"),
    $fdc09a8f996c63ba$var$load("jyfIr"),
    $fdc09a8f996c63ba$var$load("9IeAj"),
    $fdc09a8f996c63ba$var$load("kUbUu"),
    $fdc09a8f996c63ba$var$load("2PePB"),
    $fdc09a8f996c63ba$var$load("lnKog"),
    $fdc09a8f996c63ba$var$load("9ftJe"),
    $fdc09a8f996c63ba$var$load("h3ABO"),
    $fdc09a8f996c63ba$var$load("kC80R"),
    $fdc09a8f996c63ba$var$load("7EorR"),
    $fdc09a8f996c63ba$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("7nyvx", function(module, exports) {

let $55f572e864d8683b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $55f572e864d8683b$var$load("28xhU"),
    $55f572e864d8683b$var$load("2YffH"),
    $55f572e864d8683b$var$load("aT7sf"),
    $55f572e864d8683b$var$load("fRvqe"),
    $55f572e864d8683b$var$load("ev7SX"),
    $55f572e864d8683b$var$load("cFEDt"),
    $55f572e864d8683b$var$load("68ZlI"),
    $55f572e864d8683b$var$load("h4Nf7"),
    $55f572e864d8683b$var$load("7f9Fz"),
    $55f572e864d8683b$var$load("8YSo7"),
    $55f572e864d8683b$var$load("lYvov"),
    $55f572e864d8683b$var$load("k8XPW"),
    $55f572e864d8683b$var$load("fWCRm"),
    $55f572e864d8683b$var$load("g9CVe"),
    $55f572e864d8683b$var$load("aeEUI"),
    $55f572e864d8683b$var$load("eY3St"),
    $55f572e864d8683b$var$load("bkd4T"),
    $55f572e864d8683b$var$load("dTsOE"),
    $55f572e864d8683b$var$load("awqCy"),
    $55f572e864d8683b$var$load("6wr18"),
    $55f572e864d8683b$var$load("kjZZD"),
    $55f572e864d8683b$var$load("3ySTn"),
    $55f572e864d8683b$var$load("c2rHL"),
    $55f572e864d8683b$var$load("kHOMt"),
    $55f572e864d8683b$var$load("hhss7"),
    $55f572e864d8683b$var$load("cB5rV"),
    $55f572e864d8683b$var$load("aKnnM"),
    $55f572e864d8683b$var$load("iZU4p"),
    $55f572e864d8683b$var$load("Wowvf"),
    $55f572e864d8683b$var$load("ffEVr"),
    $55f572e864d8683b$var$load("jlSv2"),
    $55f572e864d8683b$var$load("1UUrt"),
    $55f572e864d8683b$var$load("1hmnv"),
    $55f572e864d8683b$var$load("1faui"),
    $55f572e864d8683b$var$load("kWZnd"),
    $55f572e864d8683b$var$load("92LGf"),
    $55f572e864d8683b$var$load("iqKwT"),
    $55f572e864d8683b$var$load("jyfIr"),
    $55f572e864d8683b$var$load("9IeAj"),
    $55f572e864d8683b$var$load("kUbUu"),
    $55f572e864d8683b$var$load("2PePB"),
    $55f572e864d8683b$var$load("lnKog"),
    $55f572e864d8683b$var$load("9ftJe"),
    $55f572e864d8683b$var$load("h3ABO"),
    $55f572e864d8683b$var$load("kC80R"),
    $55f572e864d8683b$var$load("7EorR"),
    $55f572e864d8683b$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("3LGIA", function(module, exports) {

let $2be6e5ce883d487e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2be6e5ce883d487e$var$load("28xhU"),
    $2be6e5ce883d487e$var$load("k8XPW"),
    $2be6e5ce883d487e$var$load("fWCRm"),
    $2be6e5ce883d487e$var$load("2YffH"),
    $2be6e5ce883d487e$var$load("2PePB"),
    $2be6e5ce883d487e$var$load("aT7sf"),
    $2be6e5ce883d487e$var$load("fRvqe"),
    $2be6e5ce883d487e$var$load("cFEDt"),
    $2be6e5ce883d487e$var$load("68ZlI"),
    $2be6e5ce883d487e$var$load("h4Nf7"),
    $2be6e5ce883d487e$var$load("7f9Fz"),
    $2be6e5ce883d487e$var$load("8YSo7"),
    $2be6e5ce883d487e$var$load("lYvov"),
    $2be6e5ce883d487e$var$load("g9CVe"),
    $2be6e5ce883d487e$var$load("aeEUI"),
    $2be6e5ce883d487e$var$load("eY3St"),
    $2be6e5ce883d487e$var$load("bkd4T"),
    $2be6e5ce883d487e$var$load("awqCy"),
    $2be6e5ce883d487e$var$load("6wr18"),
    $2be6e5ce883d487e$var$load("kjZZD"),
    $2be6e5ce883d487e$var$load("3ySTn"),
    $2be6e5ce883d487e$var$load("c2rHL"),
    $2be6e5ce883d487e$var$load("kHOMt"),
    $2be6e5ce883d487e$var$load("hhss7"),
    $2be6e5ce883d487e$var$load("cB5rV"),
    $2be6e5ce883d487e$var$load("aKnnM"),
    $2be6e5ce883d487e$var$load("iZU4p"),
    $2be6e5ce883d487e$var$load("Wowvf"),
    $2be6e5ce883d487e$var$load("ffEVr"),
    $2be6e5ce883d487e$var$load("jlSv2"),
    $2be6e5ce883d487e$var$load("1UUrt"),
    $2be6e5ce883d487e$var$load("1hmnv"),
    $2be6e5ce883d487e$var$load("1faui"),
    $2be6e5ce883d487e$var$load("kWZnd"),
    $2be6e5ce883d487e$var$load("92LGf"),
    $2be6e5ce883d487e$var$load("iqKwT"),
    $2be6e5ce883d487e$var$load("jyfIr"),
    $2be6e5ce883d487e$var$load("9IeAj"),
    $2be6e5ce883d487e$var$load("kUbUu"),
    $2be6e5ce883d487e$var$load("9ftJe"),
    $2be6e5ce883d487e$var$load("h3ABO"),
    $2be6e5ce883d487e$var$load("kC80R"),
    $2be6e5ce883d487e$var$load("7EorR"),
    $2be6e5ce883d487e$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("1yl1k", function(module, exports) {

let $121945a9d4281266$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $121945a9d4281266$var$load("28xhU"),
    $121945a9d4281266$var$load("k8XPW"),
    $121945a9d4281266$var$load("fWCRm"),
    $121945a9d4281266$var$load("2YffH"),
    $121945a9d4281266$var$load("aT7sf"),
    $121945a9d4281266$var$load("fRvqe"),
    $121945a9d4281266$var$load("cFEDt"),
    $121945a9d4281266$var$load("68ZlI"),
    $121945a9d4281266$var$load("h4Nf7"),
    $121945a9d4281266$var$load("7f9Fz"),
    $121945a9d4281266$var$load("8YSo7"),
    $121945a9d4281266$var$load("lYvov"),
    $121945a9d4281266$var$load("g9CVe"),
    $121945a9d4281266$var$load("aeEUI"),
    $121945a9d4281266$var$load("eY3St"),
    $121945a9d4281266$var$load("bkd4T"),
    $121945a9d4281266$var$load("awqCy"),
    $121945a9d4281266$var$load("6wr18"),
    $121945a9d4281266$var$load("kjZZD"),
    $121945a9d4281266$var$load("3ySTn"),
    $121945a9d4281266$var$load("c2rHL"),
    $121945a9d4281266$var$load("kHOMt"),
    $121945a9d4281266$var$load("hhss7"),
    $121945a9d4281266$var$load("cB5rV"),
    $121945a9d4281266$var$load("aKnnM"),
    $121945a9d4281266$var$load("iZU4p"),
    $121945a9d4281266$var$load("Wowvf"),
    $121945a9d4281266$var$load("ffEVr"),
    $121945a9d4281266$var$load("jlSv2"),
    $121945a9d4281266$var$load("1UUrt"),
    $121945a9d4281266$var$load("1hmnv"),
    $121945a9d4281266$var$load("1faui"),
    $121945a9d4281266$var$load("kWZnd"),
    $121945a9d4281266$var$load("92LGf"),
    $121945a9d4281266$var$load("iqKwT"),
    $121945a9d4281266$var$load("jyfIr"),
    $121945a9d4281266$var$load("9IeAj"),
    $121945a9d4281266$var$load("kUbUu"),
    $121945a9d4281266$var$load("2PePB"),
    $121945a9d4281266$var$load("lnKog"),
    $121945a9d4281266$var$load("9ftJe"),
    $121945a9d4281266$var$load("h3ABO"),
    $121945a9d4281266$var$load("kC80R"),
    $121945a9d4281266$var$load("7EorR"),
    $121945a9d4281266$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("61oIX", function(module, exports) {

let $0121a538d44b3608$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0121a538d44b3608$var$load("28xhU"),
    $0121a538d44b3608$var$load("k8XPW"),
    $0121a538d44b3608$var$load("fWCRm"),
    $0121a538d44b3608$var$load("2YffH"),
    $0121a538d44b3608$var$load("aT7sf"),
    $0121a538d44b3608$var$load("fRvqe"),
    $0121a538d44b3608$var$load("cFEDt"),
    $0121a538d44b3608$var$load("68ZlI"),
    $0121a538d44b3608$var$load("h4Nf7"),
    $0121a538d44b3608$var$load("7f9Fz"),
    $0121a538d44b3608$var$load("8YSo7"),
    $0121a538d44b3608$var$load("lYvov"),
    $0121a538d44b3608$var$load("g9CVe"),
    $0121a538d44b3608$var$load("aeEUI"),
    $0121a538d44b3608$var$load("eY3St"),
    $0121a538d44b3608$var$load("bkd4T"),
    $0121a538d44b3608$var$load("awqCy"),
    $0121a538d44b3608$var$load("6wr18"),
    $0121a538d44b3608$var$load("kjZZD"),
    $0121a538d44b3608$var$load("3ySTn"),
    $0121a538d44b3608$var$load("c2rHL"),
    $0121a538d44b3608$var$load("kHOMt"),
    $0121a538d44b3608$var$load("hhss7"),
    $0121a538d44b3608$var$load("cB5rV"),
    $0121a538d44b3608$var$load("aKnnM"),
    $0121a538d44b3608$var$load("iZU4p"),
    $0121a538d44b3608$var$load("Wowvf"),
    $0121a538d44b3608$var$load("ffEVr"),
    $0121a538d44b3608$var$load("jlSv2"),
    $0121a538d44b3608$var$load("1UUrt"),
    $0121a538d44b3608$var$load("1hmnv"),
    $0121a538d44b3608$var$load("1faui"),
    $0121a538d44b3608$var$load("kWZnd"),
    $0121a538d44b3608$var$load("92LGf"),
    $0121a538d44b3608$var$load("iqKwT"),
    $0121a538d44b3608$var$load("jyfIr"),
    $0121a538d44b3608$var$load("9IeAj"),
    $0121a538d44b3608$var$load("kUbUu"),
    $0121a538d44b3608$var$load("2PePB"),
    $0121a538d44b3608$var$load("lnKog"),
    $0121a538d44b3608$var$load("9ftJe"),
    $0121a538d44b3608$var$load("h3ABO"),
    $0121a538d44b3608$var$load("kC80R"),
    $0121a538d44b3608$var$load("7EorR"),
    $0121a538d44b3608$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.6d16d052.js.map
